import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vue3Toasity from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Swal from 'sweetalert2';

import "bootstrap/dist/js/bootstrap.js"
import 'bootstrap/dist/css/bootstrap.css'
import './assets/scss/main.scss';

// Attach token to every axios request if available
axios.interceptors.request.use((config) => {
  try {
    const token = JSON.parse(localStorage.getItem('access_token'));
    if (token) config.headers.Authorization = 'Bearer ' + token;
  } catch (e) {
    // ignore JSON parse errors
  }
  return config;
}, (error) => Promise.reject(error));

const app = createApp(App)
.use(router)
.use(store)
.use(VueAxios, axios)
.use(Vue3Toasity,{ autoClose: 3000 })

// Override Swal.fire for success toasts to use vue3-toastify globally
const _originalSwalFire = Swal.fire.bind(Swal);
Swal.fire = (options) => {
  try {
    if (options && options.icon === 'success') {
      const msg = options.title || options.text || 'Success';
      const toast = app.config.globalProperties.$toast;
      if (toast && typeof toast.success === 'function') {
        toast.success(msg);
        return Promise.resolve({ isConfirmed: true });
      }
    }
  } catch (e) {
    // fallback to original
    return _originalSwalFire(options);
  }
  return _originalSwalFire(options);
};

app.mixin({
    methods: {
      formatDate: function (rawDate, timeOption) {
        if(rawDate){
          const dateNo = new Date(rawDate)
          if(timeOption == "true"){
            var minutes = 0;
            if(dateNo.getMinutes() < 10){
              minutes = "0"+dateNo.getMinutes()
            } else {
              minutes = dateNo.getMinutes()
            }
            var hours = 0;
            if(dateNo.getHours() < 10){
              hours = "0"+dateNo.getHours()
            } else {
              hours = dateNo.getHours()
            }
            return dateNo.getDate()+"/"+(dateNo.getMonth()+1)+"/"+dateNo.getFullYear()+" - "+hours+":"+minutes
          } else {
            return dateNo.getDate()+"/"+(dateNo.getMonth()+1)+"/"+dateNo.getFullYear();
          }
        } else {
          return ""
        }
      },

      countPendingApprovals(array) {
        let count = 0;
        if (!array) return count;

        const permission = JSON.parse(localStorage.getItem('permission') || '{}');

        const shouldCount = (approval) => {
          if (!approval) return false;
          const moduleName = (approval.module || '').toString().toLowerCase();
          const t = (approval.type || '').toString().toLowerCase();

          if (moduleName !== 'purchase') {
            return ['pending', 'verify', 'verified', 'stamp', 'ceo_stamp'].includes(t);
          }

          // purchase module: respect permission flags
          if (t === 'verify' || t === 'verification') return !!permission.verifyPurchase;
          // 'verified' is used to indicate verification completed and ready for stamping
          if (t === 'verified') return !!permission.stampPurchase;
          if (t === 'stamp' || t === 'stamping') return !!permission.stampPurchase;
          if (t === 'ceo_stamp' || t === 'ceostamp' || t === 'ceo') return !!permission.ceoStampPurchase;
          if (t === 'pending' || t === '') return !!permission.approvePurchase;
          return false;
        };

        if (Array.isArray(array)) {
          array.forEach((obj) => { if (shouldCount(obj)) count++; });
        } else if (typeof array === 'object') {
          Object.values(array).forEach((obj) => { if (shouldCount(obj)) count++; });
        }

        return count;
      },


      truncateString(str) {
        return str.length > 100 ? str.substring(0, 100) + '...' : str;
      },


      filterApprovals(approvals, arg) {
        const permission = JSON.parse(localStorage.getItem('permission') || '{}');
        if (arg === "pending") {
          return approvals.filter(approval => {
            // Non-purchase modules: keep existing behavior
            if (approval.module && approval.module.toLowerCase() !== 'purchase' && approval.module !== 'purchase') {
              return approval.type === 'pending' || approval.type === 'verify' || approval.type === 'stamp' || approval.type === 'ceo_stamp';
            }

            // Purchase module: only show types the user has permission for
            const t = (approval.type || '').toString().toLowerCase();
            if (t === 'verify' || t === 'verification') return !!permission.verifyPurchase;
            if (t === 'stamp' || t === 'stamping') return !!permission.stampPurchase;
            if (t === 'ceo_stamp' || t === 'ceostamp' || t === 'ceo') return !!permission.ceoStampPurchase;
            if (t === 'pending' || t === '') return !!permission.approvePurchase; // show initial pending to purchase approvers
            return false;
          });
        } else if (arg == "processed") {
          return approvals.filter(approval => approval.type != "pending");
        } else if (arg == "urgent") {
          return approvals.filter(approval => (approval.priority === "urgent" && approval.type === "pending"));
        }
      },

      formatMoney: function (value) {
        if(value > 0) {
          return new Intl.NumberFormat('en-US', { style: 'currency',currency: 'KES',currencyDisplay: 'narrowSymbol' }).format(value);
        } else {
          return "0.00";
        }
      },
      formatQty: function (value) {
        if(value > 0) {
          return new Intl.NumberFormat().format(value);
        } else {
          return "0";
        }
      },
    
      async shortenUrl(url){
        console.log(url)
        const body =  {
          apiKey: "6648972db05ab3793ed113d8",
          projectName:"Test1",
          email:"dev.pasaka@gmail.com",
          longUrl:url
        }
        try{
          const res = await axios.post('https://pentagonapi.pavicontech.com/api/v1/shorty/shorten', body)
          return res.data.shortenedUrl.shortUrl
        }catch(err){
          console.log("Url Shortener Error", err)
        }

      }, 
    },
  })
.mount('#app')